import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalController, NavParams, IonSlides } from '@ionic/angular';
import { ToastService } from '@app/core/services/toast/toast.service';
import { SwiperComponent } from 'swiper/angular';
import { SwiperModule } from 'swiper/angular';
import { faSearchMinus, faSearchPlus, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { ImgPipe } from '@app/shared/pipes/img/img.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-image-slide',
    templateUrl: './image-slide.component.html',
    styleUrls: ['./image-slide.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, ImgPipe, SwiperModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ImageSlideComponent implements OnInit {
    @ViewChild(IonSlides) slider: IonSlides;
    @ViewChild('Swiper', { static: true }) Swiper?: SwiperComponent;

    faSearchMinus = faSearchMinus;
    faSearchPlus = faSearchPlus;
    faTimes = faTimes;
    program: any;
    image: any;
    imagesArr = [];
    position = 0;

    sliderOpts = {
        zoom: {
            containerClass: 'swiper-zoom-container',
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            zoomedSlideClass: 'swiper-slide-zoomed',
        },
    };

    constructor(private navParams: NavParams, private modalCtrl: ModalController, private toastService: ToastService) {}

    ngOnInit() {
        this.image = this.navParams.get('image');
        this.program = this.navParams.get('program');
        this.position = this.navParams.get('index');

        if (this.program.image.length > 0) {
            this.imagesArr = this.program.image.filter((image) => image.size === 'md' && image.Key.endsWith('.webp'));
        } else {
            // load default image?
            // this.imagesArr = this.program?.state?.img;
        }
    }

    showToasterMessage(message: string) {
        this.toastService.create({
            message: message,
            duration: 3000,
            position: 'top',
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    },
                },
            ],
            color: 'danger',
        });
    }

    zoom(zoomIn: boolean) {
        // const slider =  this.Swiper.zoom.in();
        // const zoom = slider.zoom;
        if (zoomIn) {
            this.Swiper.swiperRef.zoom.in();
        } else {
            this.Swiper.swiperRef.zoom.out();
        }
    }

    close() {
        this.modalCtrl.dismiss();
    }
}
